"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERequestType = exports.ERecycledType = exports.ELoginRole = exports.EGeoObjectType = exports.EGeoObjectStatus = exports.EFileType = exports.EClientPlatform = exports.EAttachmentType = exports.EArticleType = void 0;
var EArticleType;
(function (EArticleType) {
    EArticleType["Help"] = "Help";
    EArticleType["Law"] = "Law";
    EArticleType["News"] = "News";
    EArticleType["Special"] = "Special";
})(EArticleType = exports.EArticleType || (exports.EArticleType = {}));
var EAttachmentType;
(function (EAttachmentType) {
    EAttachmentType["ArticleContent"] = "ArticleContent";
    EAttachmentType["ArticlePromo"] = "ArticlePromo";
    EAttachmentType["GeoObjectGallery"] = "GeoObjectGallery";
    EAttachmentType["SupportTicket"] = "SupportTicket";
})(EAttachmentType = exports.EAttachmentType || (exports.EAttachmentType = {}));
var EClientPlatform;
(function (EClientPlatform) {
    EClientPlatform["Android"] = "Android";
    EClientPlatform["Ios"] = "Ios";
    EClientPlatform["Unknown"] = "Unknown";
    EClientPlatform["Web"] = "Web";
})(EClientPlatform = exports.EClientPlatform || (exports.EClientPlatform = {}));
var EFileType;
(function (EFileType) {
    EFileType["Image"] = "Image";
    EFileType["Unknown"] = "Unknown";
})(EFileType = exports.EFileType || (exports.EFileType = {}));
var EGeoObjectStatus;
(function (EGeoObjectStatus) {
    EGeoObjectStatus["Approved"] = "Approved";
    EGeoObjectStatus["New"] = "New";
    EGeoObjectStatus["Rejected"] = "Rejected";
})(EGeoObjectStatus = exports.EGeoObjectStatus || (exports.EGeoObjectStatus = {}));
var EGeoObjectType;
(function (EGeoObjectType) {
    EGeoObjectType["Containers"] = "Containers";
    EGeoObjectType["Stationary"] = "Stationary";
    EGeoObjectType["Temporary"] = "Temporary";
})(EGeoObjectType = exports.EGeoObjectType || (exports.EGeoObjectType = {}));
var ELoginRole;
(function (ELoginRole) {
    ELoginRole["Admin"] = "Admin";
    ELoginRole["Moderator"] = "Moderator";
    ELoginRole["User"] = "User";
})(ELoginRole = exports.ELoginRole || (exports.ELoginRole = {}));
var ERecycledType;
(function (ERecycledType) {
    ERecycledType["Battery"] = "Battery";
    ERecycledType["Clothes"] = "Clothes";
    ERecycledType["Dangerous"] = "Dangerous";
    ERecycledType["Electronics"] = "Electronics";
    ERecycledType["Food"] = "Food";
    ERecycledType["Glass"] = "Glass";
    ERecycledType["Huge"] = "Huge";
    ERecycledType["Lamp"] = "Lamp";
    ERecycledType["Metall"] = "Metall";
    ERecycledType["Other"] = "Other";
    ERecycledType["Paper"] = "Paper";
    ERecycledType["Plastic"] = "Plastic";
    ERecycledType["Tetrapak"] = "Tetrapak";
    ERecycledType["Thermometer"] = "Thermometer";
    ERecycledType["Wrap"] = "Wrap";
})(ERecycledType = exports.ERecycledType || (exports.ERecycledType = {}));
var ERequestType;
(function (ERequestType) {
    ERequestType["Add"] = "Add";
    ERequestType["Littered"] = "Littered";
    ERequestType["Other"] = "Other";
    ERequestType["Overfilled"] = "Overfilled";
})(ERequestType = exports.ERequestType || (exports.ERequestType = {}));
//# sourceMappingURL=types.js.map